import { cloneDeep } from "lodash"
import { toast } from '../../libs/utils'
const dataTemplate = {
  '患者手术综合评估建议': [
    {
      '评估结论': [
        {
          label: '评估结论',
          name: 'diagnose',
          type: 'textArea',
          inputVal: ''
        }
      ]
    }
  ],
  '形态学指标分析': [
    {
      'CTA整体三维重建分析':  [
        {
          name: 'Analysis_of_CTA_Whole_3D_Reconstruction',
          type: 'onlyImage',
          iamgeNum: 4,
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          imageList: [
            {
              name: 'cta_whole_3d_reconstruction_1',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_2',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_3',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_4',
              url: ''
            }
          ]
        },
        {
          name: 'Analysis_of_CTA_Whole_3D_Reconstruction',
          type: 'onlyImage',
          iamgeNum: 4,
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          imageList: [
            {
              name: 'cta_whole_3d_reconstruction_1',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_2',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_3',
              url: ''
            },
            {
              name: 'cta_whole_3d_reconstruction_4',
              url: ''
            }
          ]
        }
        // {
        //   name: 'Analysis_of_CTA_Whole_3D_Reconstruction',
        //   type: 'onlyImage',
        //   iamgeNum: 4,
        //   imageList: [
        //     {
        //       name: 'cta_whole_3d_reconstruction_1',
        //       url: ''
        //     },
        //     {
        //       name: 'cta_whole_3d_reconstruction_2',
        //       url: ''
        //     },
        //     {
        //       name: 'cta_whole_3d_reconstruction_3',
        //       url: ''
        //     },
        //     {
        //       name: 'cta_whole_3d_reconstruction_4',
        //       url: ''
        //     }
        //   ]
        // }
      ],
      '影像分析': [
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        },
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        },
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        },
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        },
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        },
        {
          name: 'Image_Analysis',
          type: 'textAndImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          iamgeNum: 4,
          imageList: [
            {
              name: 'image_analysis_1',
              url: ''
            },
            {
              name: 'image_analysis_2',
              url: ''
            },
            {
              name: 'image_analysis_3',
              url: ''
            },
            {
              name: 'image_analysis_4',
              url: ''
            }
          ],
          inputVal: ''
        }
      ]
    }
  ],
  "功能学（FFR）指标分析": [
    {
      'FFR整体三维重建分析':  [
        {
          name: 'multicolour',
          label: 'FFR-全局预览图',
          type: 'onlyImage',
          imageSize: '14x15cm/1654x1772像素(宽x高)',
          imageList: [
            {
              name: 'FFR-Globalview1',
              url: ''
            },
            {
              name: 'FFR-Globalview2',
              url: ''
            },
            {
              name: 'FFR-Globalview3',
              url: ''
            }
          ]
        },
        {
          name: 'multicolour',
          label: 'FFR-LAD预览图',
          type: 'onlyImage',
          imageSize: '14x15cm/1654x1772像素(宽x高)',
          imageList: [
            {
              name: 'FFR-LAD1',
              url: ''
            },
            {
              name: 'FFR-LAD2',
              url: ''
            }
          ]
        },
        {
          name: 'multicolour',
          label: 'FFR-LCX预览图',
          type: 'onlyImage',
          imageSize: '14x15cm/1654x1772像素(宽x高)',
          imageList: [
            {
              name: 'FFR-LCX1',
              url: ''
            },
            {
              name: 'FFR-LCX2',
              url: ''
            }
          ]
        },
        {
          name: 'multicolour',
          label: 'FFR-RCA预览图',
          imageSize: '14x15cm/1654x1772像素(宽x高)',
          type: 'onlyImage',
          imageList: [
            {
              name: 'FFR-RCA1',
              url: ''
            },
            {
              name: 'FFR-RCA2',
              url: ''
            }
          ]
        },
        {
          name: 'white',
          label: 'FFR全局几何模型图',
          type: 'onlyImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          imageList: [
            {
              name: 'Geo-Globalview1',
              url: ''
            },
            {
              name: 'Geo-Globalview2',
              url: ''
            }
          ]
        },
        {
          name: 'white',
          label: 'FFR-LAD几何模型图',
          type: 'onlyImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          imageList: [
            {
              name: 'Geo-StenosisLAD1',
              url: ''
            },
            {
              name: 'Geo-StenosisLAD2',
              url: ''
            }
          ]
        },
        {
          name: 'white',
          label: 'FFR-LCX几何模型图',
          type: 'onlyImage',
          imageSize: '7.6x7.4cm/874x898像素',
          imageList: [
            {
              name: 'Geo-StenosisLCX1',
              url: ''
            },
            {
              name: 'Geo-StenosisLCX2',
              url: ''
            }
          ]
        },
        {
          name: 'white',
          label: 'FFR-RCA几何模型图',
          type: 'onlyImage',
          imageSize: '7.6x7.6cm/898x898像素(宽x高)',
          imageList: [
            {
              name: 'Geo-StenosisRCA1',
              url: ''
            },
            {
              name: 'Geo-StenosisRCA2',
              url: ''
            }
          ]
        }
      ],
      '左前降支': [
        {
          label: '左前降支FFR分数',
          type: 'onlyNum',
          name: 'Left_Anterior_Descending_Artery',
          inputVal: '',
          valUnit: ''
        },
      ],
      '左回旋支': [
        {
          label: '左回旋支FFR分数',
          type: 'onlyNum',
          name: 'Left_Circumflex_Artery',
          inputVal: '',
          valUnit: ''
        },
      ],
      '右冠状动脉': [
        {
          label: '右冠状动脉FFR分数',
          type: 'onlyNum',
          name: 'Right_Coronary_Artery',
          inputVal: '',
          valUnit: ''
        }
      ]
    }
  ]
}



// 构造提交参数

function createParams(reportData) {
  let params = {
    diagnose: '',
    detail: {},
    Analysis_of_CTA_Whole_3D_Reconstruction: [],
    Analysis_of_FFR_Whole_3D_Reconstruction: {
      multicolour: [],
      white: []
    },
    Image_Analysis: []
  }
  params.diagnose = reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal']
  
  if (reportData['功能学（FFR）指标分析'][0]['左前降支'][0]['inputVal'] > 1) {
    toast({msg: '左前降支FFRf分数数值错误', type: 'error'})
    return false
  }
  if (reportData['功能学（FFR）指标分析'][0]['左回旋支'][0]['inputVal'] > 1) {
    toast({msg: '左回旋支FFRf分数数值错误', type: 'error'})
    return false
  }
  if (reportData['功能学（FFR）指标分析'][0]['右冠状动脉'][0]['inputVal'] > 1) {
    toast({msg: '右冠状动脉FFRf分数数值错误', type: 'error'})
    return false
  }
  params.detail.Left_Anterior_Descending_Artery = {
    value: reportData['功能学（FFR）指标分析'][0]['左前降支'][0]['inputVal']
  }
  params.detail.Left_Circumflex_Artery = {
    value: reportData['功能学（FFR）指标分析'][0]['左回旋支'][0]['inputVal']
  }
  params.detail.Right_Coronary_Artery = {
    value: reportData['功能学（FFR）指标分析'][0]['右冠状动脉'][0]['inputVal']
  }
  let ctaImages = reportData['形态学指标分析'][0]['CTA整体三维重建分析']
  for(let i = 0; i < ctaImages.length; i++) {
    let item = ctaImages[i]
    let obj = {
      image: []
    }
    for (let i = 0; i < item.imageList.length; i++) {
      obj.image.push(item.imageList[i]['url'])
    }
    params.Analysis_of_CTA_Whole_3D_Reconstruction.push(obj)
  }
  let ffrImagesObjs = reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析']
  for(let i = 0; i < ffrImagesObjs.length; i++) {
    let obj = ffrImagesObjs[i]
    for (let j = 0; j < obj.imageList.length; j++) {
      if (obj.name === 'multicolour') {
        params['Analysis_of_FFR_Whole_3D_Reconstruction']['multicolour'].push({
          title: obj.imageList[j]['name'],
          pic: obj.imageList[j]['url']
        })
      } else if (obj.name === 'white') {
        params['Analysis_of_FFR_Whole_3D_Reconstruction']['white'].push({
          title: obj.imageList[j]['name'],
          pic: obj.imageList[j]['url']
        })
      }
    }
  }
  // 影像分析
  let analysisImgs = reportData['形态学指标分析'][0]['影像分析']
  for (let i = 0; i < analysisImgs.length; i++) {
    let item = analysisImgs[i]
    let obj = {
      image: [],
      diagnose: item.inputVal
    }
    for (let i = 0; i < item.imageList.length; i++) {
      obj.image.push(item.imageList[i]['url'])
    }
    params.Image_Analysis.push(obj)
  }
  return params
}

// 解析JSON
function parseJsonObj(jsonObj) {
  let reportData = cloneDeep(dataTemplate)
  for (let k in jsonObj) {
    let item = jsonObj[k]
    // 取出评估结论
    if (k === 'diagnose') reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal'] = item
    // CTA整体三维重建分析
    if (k === 'Analysis_of_CTA_Whole_3D_Reconstruction') {
      for (let i = 0; i < item.length; i++) {
        let imageList = item[i]['image']
        let destImgItem = reportData['形态学指标分析'][0]['CTA整体三维重建分析'][i]
        for (let j = 0; j < imageList.length; j++) {
          destImgItem['imageList'][j]['url'] = imageList[j]
        }
      }
    }
    // 影像分析
    if (k === 'Image_Analysis') {
      for (let i = 0; i < item.length; i++) {
        let imageList = item[i]['image']
        let destImgItem = reportData['形态学指标分析'][0]['影像分析'][i]
        for (let j = 0; j < imageList.length; j++) {
          destImgItem['imageList'][j]['url'] = imageList[j]
        }
        destImgItem.inputVal = item[i]['diagnose']
      }
    }
    // FFR整体三维重建分析
    if (k === 'Analysis_of_FFR_Whole_3D_Reconstruction') {
      let multicolourImgs = item.multicolour
      let whiteImgs = item.white
      for (let i = 0; i < multicolourImgs.length; i++) {
        let imageItem = multicolourImgs[i]
        let index = 1 * imageItem.title.charAt(imageItem.title.length -1)
        if (imageItem.title.indexOf('FFR-Globalview')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][0]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('FFR-LAD')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][1]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('FFR-LCX')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][2]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('FFR-RCA')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][3]['imageList'][index - 1]['url'] = imageItem['pic']
        }
      }
      for (let i = 0; i < whiteImgs.length; i++) {
        let imageItem = whiteImgs[i]
        let index = 1 * imageItem.title.charAt(imageItem.title.length -1)
        if (imageItem.title.indexOf('Geo-Globalview')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][4]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('Geo-StenosisLAD')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][5]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('Geo-StenosisLCX')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][6]['imageList'][index - 1]['url'] = imageItem['pic']
        } else if (imageItem.title.indexOf('Geo-StenosisRCA')!== -1) {
          reportData['功能学（FFR）指标分析'][0]['FFR整体三维重建分析'][7]['imageList'][index - 1]['url'] = imageItem['pic']
        }
      }
    }
    if (k === 'detail') {
      for (let key in item) {
        if (key === 'Left_Anterior_Descending_Artery') {
          reportData['功能学（FFR）指标分析'][0]['左前降支'][0]['inputVal'] = item[key]['value']
        } else if (key === 'Left_Circumflex_Artery') {
          reportData['功能学（FFR）指标分析'][0]['左回旋支'][0]['inputVal'] = item[key]['value']
        } else if (key === 'Right_Coronary_Artery') {
          reportData['功能学（FFR）指标分析'][0]['右冠状动脉'][0]['inputVal'] = item[key]['value']
        } 
      }
    }
  }
  return reportData
}




export default {dataTemplate, createParams, parseJsonObj, reportType: 'CHD'}